/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'

import useMedia from '../../helpers/useMedia'
import * as Styled from './ArgosCardPrompt.styles'

const argosCardImage = {
  ALT:
    'Spread the cost with an Argos Card Credit Plan. Representative 34.9% APR variable. Credit subject to status. T&Cs apply. Click here to find out and learn more',
  DESKTOP: 'https://media.4rgos.it/i/Argos/argoscard-desktop?w=1140',
  TABLET: 'https://media.4rgos.it/i/Argos/argoscard-tablet?w=768',
  MOBILE: 'https://media.4rgos.it/i/Argos/argoscard-mobile?w=481',
}

const linkUrl = '//www.argos.co.uk/help/argos-card?tag=ar:homepage:argoscardbanner'

const ArgosCardPrompt = ({ onCmsClick }) => {
  const argosCardImg = useMedia(
    [argosCardImage.DESKTOP, argosCardImage.TABLET, argosCardImage.TABLET, argosCardImage.MOBILE],
    null,
  )

  if (!argosCardImg) return null
  return (
    <div className='container' data-test='argos-card-prompt'>
      <Styled.ArgosCard
        onClick={(event) => onCmsClick(event, linkUrl)}
        href={linkUrl}
        data-test='argos-card-prompt-link'
        title={argosCardImage.ALT}>
        <Styled.ArgosCardImage src={argosCardImg} data-test='image-argos-card' lazy alt={argosCardImage.ALT} />
      </Styled.ArgosCard>
    </div>
  )
}

ArgosCardPrompt.propTypes = {
  onCmsClick: PropTypes.func.isRequired,
}

export default ArgosCardPrompt
